import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { App } from "antd";
import { TIENDA_COLEGIOS, LOADING_TIENDA_COLEGIO } from "../store/selectors";
import {
  setLoading,
  setTiendaColegios,
  deleteTiendaColegio as deleteTiendaColegioAction,
} from "../store/slices/tiendaColegio";
import {
  getTiendaColegios,
  getTiendaColegio as getTiendaColegioService,
  deleteTiendaColegio as deleteTiendaColegioService,
} from "../services/tienda-colegios/tienda-colegio.service";

export const useTiendaColegios = () => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const tiendaColegios = useSelector(TIENDA_COLEGIOS);
  const loading = useSelector(LOADING_TIENDA_COLEGIO);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      if (tiendaColegios.length > 0) {
        dispatch(setLoading(false));
        return;
      }
      const data = await getTiendaColegios();
      dispatch(setTiendaColegios(data));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification.error({
        message: "Error",
        description: "No se pudieron cargar los colegios tienda.",
        placement: "top",
        duration: 3,
      });
    }
  };

  const getTiendaColegioById = async (id: number) => {
    try {
      return await getTiendaColegioService(id);
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: "No se pudo cargar el colegio.",
        placement: "top",
        duration: 3,
      });
      return null;
    }
  };

  const deleteTiendaColegio = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      const ok = await deleteTiendaColegioService(id);
      dispatch(setLoading(false));
      if (ok) {
        dispatch(deleteTiendaColegioAction(id));
        notification.success({
          message: "Éxito",
          description: "El colegio fue eliminado exitosamente.",
          placement: "top",
          duration: 3,
        });
        return true;
      }
      notification.error({
        message: "Error",
        description: "No se pudo eliminar el colegio.",
        placement: "top",
        duration: 3,
      });
      return false;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message || "No se pudo eliminar el colegio.",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    loading,
    tiendaColegios,
    getTiendaColegioById,
    deleteTiendaColegio,
  };
};
